import { FormControl, FormHelperText, InputAdornment, InputProps } from '@mui/material';
import { FC } from 'react';
import { Input } from '../inputField';
import { InputFieldLabel } from '../shared/fieldLabel';

type Props = InputProps & {
  label?: string;
  futureEditingLocked?: boolean;
  helperText?: string | false;
  missing?: boolean;
  missingMessage?: string;
  rightAlign?: boolean;
};
export type TextFieldProps = Props;

export const TextField: FC<Props> = ({
  label,
  futureEditingLocked,
  helperText,
  missing,
  missingMessage,
  rightAlign,
  ...otherProps
}) => {
  return (
    <FormControl fullWidth>
      {label && (
        <InputFieldLabel
          label={label}
          required={otherProps.required}
          futureEditingLocked={futureEditingLocked}
          missing={missing}
          missingMessage={missingMessage}
        />
      )}
      <Input
        {...otherProps}
        startAdornment={
          otherProps.startAdornment && (
            <InputAdornment position="start">{otherProps.startAdornment}</InputAdornment>
          )
        }
        endAdornment={
          otherProps.endAdornment && (
            <InputAdornment position="end">{otherProps.endAdornment}</InputAdornment>
          )
        }
        rightAlign={rightAlign}
      />
      {helperText && (
        <FormHelperText
          sx={(theme) => ({
            marginLeft: '12px',
            color: otherProps.error ? theme.palette.error.main : theme.palette.grey['600']
          })}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
